<div class="widget-checkbox-v0-tree">
  <div class='checkbox-search-bar'>
    <pt-icon [key]='IconSearch' class='btn btn-link start-action'></pt-icon>
    <input
      (ngModelChange)="search($event)"
      [(ngModel)]='currentFilter'
      [autofocus]="true"
      [disabled]='false'
      [id]='searchId'
      autocomplete='false'
      class='form-control'
      type='text'>
    <div class='end-action'>
      <pt-icon (click)='reset()' [key]='IconClose' class='btn btn-link '></pt-icon>
    </div>
  </div>
  <div *ngIf="showShowOnlySelectedFilter" class="form-check mb-3">
    <input (ngModelChange)="applyFilter($event)" [ngModel]="filterChecked" class="form-check-input" id="flexCheckDefault"
           type="checkbox">
    <label class="form-check-label" for="flexCheckDefault">
      {{ 'LABELS.SHOW_ONLY_SELECTED' | translate }}
    </label>
  </div>


  <ag-grid-angular
    *ngIf="rowData"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="selectionChanged($event)"
    [animateRows]="false"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [cacheQuickFilter]="true"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [excludeChildrenWhenTreeDataFiltering]="false"
    [floatingFiltersHeight]="floatingFiltersHeight"
    [getDataPath]="getDataPath"
    [groupSelectsChildren]="true"
    [headerHeight]="headerHeight"
    [rowData]="rowData"
    [rowHeight]="rowHeight"
    [rowMultiSelectWithClick]="true"
    [rowSelection]="'multiple'"
    [treeData]="true"
    class="ag-theme-balham w-100"
    style="height: 240px;"
  ></ag-grid-angular>
</div>
